/**
 * SVG 문자열을 data URL로 변환하는 유틸 함수
 * @param stringSVG - 변환할 SVG 문자열
 * @returns data URL 문자열 (예: "data:image/svg+xml;utf8,%3Csvg...")
 */
export function stringSVGToDataURI(stringSVG: string): string {
  try {
    const encodedSVG = encodeURIComponent(stringSVG)

    return `data:image/svg+xml;utf8,${encodedSVG}`
  } catch (error) {
    console.error('Error converting SVG to data URI:', error)

    return ''
  }
}
